<template>
  <div id="wrapper" class="noheader">
    <div class="content">
      <div class="caption">
        <div class="inner">
          <span></span>
          <p>木生婦幼診所</p>
          <span></span>
        </div>
        <a
          v-if="$store.state.from === '/FeedBack'"
          @click="backHome"
          class="arr"
          ><div class="inner"></div
        ></a>
      </div>
      <div class="surveyBox">
        <div class="title">
          <h2 style="text-align: center;">
            顧客滿意度調查
          </h2>
        </div>
        <p style="color: #999999; text-align: justify;">
          親愛的爸爸媽媽您好:
          <br />
          感謝您入住木生護理之家，與我們分享為人父母的初生之喜，入住期間期盼我們的努力有為您帶來些許的收穫。
          <br />
          為了提供更優質的服務品質，懇請您利用幾分鐘的時間，填寫這份問卷。您的反饋是我們進步的動力，若您需要即刻地改善，請寫下姓名與電話，並請提供建議或改善事項，我們會盡快處理，感謝您的指教與支持。
        </p>
        <br />
        <div class="formBox">
          <form action="javascript:void(0);">
            <h3 style="text-align: center;">
              入住背景
            </h3>
            <br />
            <p style="display:inline;">
              請問您是初次入住木生產後護理之家嗎?
            </p>
            <p style="color: red; display:inline-block;">（必填）</p>
            <br />
            <br />
            <select v-model="survey['初次住院']">
              <option value="">請選擇下列選項</option>
              <option value="是">是</option>
              <option value="否">否</option>
            </select>
            <p style="display:inline;">
              請問您此次入住的房間號碼為
            </p>
            <p style="color: red; display:inline-block;">（必填）</p>
            <br />
            <br />
            <input
              v-model="survey['房間號碼']"
              type="text"
              class="inputBox line"
            />
            <br />
            <br />
            <h3 style="text-align: center;">
              診所醫療設施與病房服務
            </h3>
            <br />
            <div
              v-for="(questionSet, number) in satisfactoinQuestion"
              :key="number"
            >
              <b>
                {{ satisfactoinTitle[number] }}
              </b>
              <b style="color: red;" v-if="number !== 0">（必填）</b>
              <br />
              <br />
              <div v-for="question in questionSet" :key="question">
                <p style="color: #999999;">
                  {{ question }}
                </p>
                <br />
                <select v-model="survey[question]">
                  <option value="">請選擇下列選項</option>
                  <option value="滿意">滿意</option>
                  <option value="普通">普通</option>
                  <option value="不滿意">不滿意</option>
                  <option value="沒接觸">沒接觸</option>
                </select>
              </div>
            </div>
            <b>
              入住期間確實學習到以下哪些照護課程
            </b>
            <b style="color: red;">(必填)</b>
            <br />
            <br />
            <div class="checksBox">
              <label class="checkMC"
                ><input
                  v-model="survey['照護課程']['母乳保存方式']"
                  type="checkbox"
                />
                <div class="box"></div>
                母乳保存方式</label
              >
              <br />
              <label class="checkMC"
                ><input
                  v-model="survey['照護課程']['泡奶或溫奶方式']"
                  type="checkbox"
                />
                <div class="box"></div>
                泡奶或溫奶方式</label
              >
              <br />
              <label class="checkMC"
                ><input
                  v-model="survey['照護課程']['瓶餵方式']"
                  type="checkbox"
                />
                <div class="box"></div>
                瓶餵方式</label
              >
              <br />
              <label class="checkMC"
                ><input
                  v-model="survey['照護課程']['三種以上的哺乳姿勢']"
                  type="checkbox"
                />
                <div class="box"></div>
                三種以上的哺乳姿勢</label
              >
              <br />
              <label class="checkMC"
                ><input
                  v-model="survey['照護課程']['溢奶與吐奶的區別與護理']"
                  type="checkbox"
                />
                <div class="box"></div>
                溢奶與吐奶的區別與護理</label
              >
              <br />
              <label class="checkMC"
                ><input
                  v-model="survey['照護課程']['塞奶時如何處理']"
                  type="checkbox"
                />
                <div class="box"></div>
                塞奶時如何處理</label
              >
              <br />
              <label class="checkMC"
                ><input
                  v-model="survey['照護課程']['寶寶腹脹評估方式及處理']"
                  type="checkbox"
                />
                <div class="box"></div>
                寶寶腹脹評估方式及處理
              </label>
              <label class="checkMC"
                ><input
                  v-model="survey['照護課程']['寶寶更換尿布']"
                  type="checkbox"
                />
                <div class="box"></div>
                寶寶更換尿布
              </label>
              <label class="checkMC"
                ><input
                  v-model="survey['照護課程']['寶寶洗澡與口腔清潔']"
                  type="checkbox"
                />
                <div class="box"></div>
                寶寶洗澡與口腔清潔
              </label>
              <label class="checkMC"
                ><input
                  v-model="survey['照護課程']['疫苗接種的必要性']"
                  type="checkbox"
                />
                <div class="box"></div>
                疫苗接種的必要性
              </label>
            </div>
            <!-- 總結 -->
            <h3 style="text-align: center;">
              總結
            </h3>
            <br />
            <p>
              請您為本次就醫總體滿意度打一個分數
            </p>
            <br />
            <select v-model="survey['滿意度分數']">
              <option value="">請選擇下列選項</option>
              <option value="90以上">90以上</option>
              <option value="80-90分">80-90分</option>
              <option value="70-79分">70-79分</option>
              <option value="60分以下">60分以下</option>
            </select>
            <br />
            <p>呈上，如有不滿意的地方，歡迎給我們建議的做法。</p>
            <input
              v-model="survey['建議做法']"
              type="text"
              class="inputBox line"
            />
            <br />
            <br />
            <p>
              請問您是否願意推薦木生診所給您的親友？
            </p>
            <br />
            <select v-model="survey['是否推薦']">
              <option value="">請選擇下列選項</option>
              <option value="非常願意">非常願意</option>
              <option value="願意">願意</option>
              <option value="普通">普通</option>
              <option value="不願意">不願意</option>
              <option value="非常不願意">非常不願意</option>
            </select>
            <br />

            <br />
            <p>
              如您願意嘉獎某位工作人員，請填下他的姓名
            </p>
            <br />
            <input
              v-model="survey['嘉獎工作人員姓名']"
              type="text"
              class="inputBox line"
            />
            <br />
            <br />

            <p>如您希望投訴某位工作人員，請填下他的姓名</p>
            <br />
            <input
              v-model="survey['被投訴員工姓名']"
              type="text"
              class="inputBox line"
            />
            <br />
            <p>
              不滿意之描述
            </p>
            <br />
            <textarea
              v-model="survey['不滿意描述']"
              placeholder="訊息輸入"
            ></textarea>
            <br />
            <p>
              對於上述事項，如同意我們與您進一步聯絡，請留下聯絡方式
              請留下您的姓名與聯絡電話，專人會儘快與您聯絡，謝謝。
            </p>
            <br />
            <input
              v-model="survey['聯絡方式']"
              type="text"
              class="inputBox line"
            />

            <p style="display:inline;">
              您的入住日期為
            </p>
            <p style="color: red; display:inline-block;">（必填）</p>
            <br />
            <br />
            <input
              v-model="survey['入住日期']"
              type="date"
              class="inputBox line"
            />
            <br />

            <br />
            <p style="display:inline;">
              本份問卷是由
            </p>
            <p style="color: red; display:inline-block;">（必填）</p>
            <br />
            <br />
            <select v-model="survey['填寫人']">
              <option value="">請選擇下列選項</option>
              <option value="媽咪本人填寫">媽咪本人填寫</option>
              <option value="親友代填">親友代填</option>
            </select>
            <p style="color: #999999; text-align: justify;">
              問卷到此告一段落 : ) 再次感謝您的耐心分享，
              您的批評與指教是我們最寶貴的禮物。<br />
              木生全體醫護人員，在此向您鞠躬致謝。<br />
              祝願您擁有美好的一天！
            </p>
            <br />
            <input
              @click.prevent="submitForm"
              type="submit"
              class="submitBtn"
              value="確認送出"
            />
          </form>
        </div>
      </div>
    </div>
  </div>
  <modal v-if="modal.display" @close="closeModal">
    <template #header>{{ modal.header }}</template>
    <template #body>{{ modal.body }}</template>
  </modal>
</template>
<script>
import { reactive, ref } from "vue";
import { useRouter } from "vue-router";
const returnRouter = () => {
  const router = useRouter();

  const goTo = destination => {
    router.replace(destination);
  };
  return {
    goTo
  };
};
import store from "../../store/index.js";
import api from "../../api";
export default {
  setup() {
    const { goTo } = returnRouter();
    const survey = ref({
      照護課程: {}
    });
    const modal = reactive({});

    const satisfactoinTitle = reactive([
      "環境與設施",
      "客服人員服務滿意度",
      "護理人員服務滿意度",
      "育嬰室人員服務滿意度",
      "醫師巡診服務滿意度"
    ]);
    const satisfactoinQuestion = ref([
      [
        "住房環境設計",
        "空調冷暖適中",
        "病房光線適中",
        "床被單舒適清潔",
        "餐飲膳食美味",
        "貼心的衛浴設備",
        "住房內備品完善",
        "儲物收納合理",
        "住房夜間安寧",
        "樓層指示圖易懂",
        "門禁把關嚴謹"
      ],

      [
        "簽約服務態度",
        "入住導覽服務",
        "櫃檯客服態度",
        "電話應答態度",
        "對訪客的招呼",
        "送餐與清潔人員的服務態度"
      ],

      [
        "記得媽咪的名字",
        "產後傷口照護",
        "母乳哺育指導",
        "護理人員尊重您的隱私"
      ],

      [
        "溫柔地照顧寶寶",
        "詳細記錄寶寶狀況",
        "寶寶頭型換邊",
        "新生兒黃疸照護",
        "新生兒沐浴教學",
        "新生兒照護指導"
      ],
      ["小兒科醫師巡診", "婦產科醫師巡診"]
    ]);

    function submitForm() {
      // console.log(survey);
      // let questionPass = [null, true, true, true, true];
      // questionPass.forEach((_, index) => {
      //   if (index === 0) {
      //     return;
      //   }
      //   satisfactoinQuestion.value[index].forEach(question => {
      //     questionPass[index] = questionPass[index] && survey.value[question];
      //   });
      // });

      // let coursePass = Object.keys(survey.value.照護課程).length && true;

      // for (let prop in survey.value.照護課程) {
      //   coursePass = coursePass && survey.value.照護課程[prop];
      // }

      // // [檢查項目,錯誤訊息]
      // const checkingList = [
      //   [survey.value.初次住院, "是否初次住院"],
      //   [survey.value.房間號碼, "房間號碼"],
      //   [questionPass[1], "客服人員服務滿意度"],
      //   [questionPass[2], "護理人員服務滿意度"],
      //   [questionPass[3], "育嬰室人員服務滿意度"],
      //   [questionPass[4], "醫師巡診服務滿意度"],
      //   [coursePass, "照護課程"],
      //   [survey.value.入住日期, "入住日期"],
      //   [survey.value.填寫人, "填寫人"]
      // ];
      // // 檢查是否通過
      // let passChecking = true;
      // checkingList.forEach(item => {
      //   passChecking = passChecking && item[0];
      // });

      // // guard
      // if (!passChecking) {
      //   let bodyMessage = "請補足以下欄位：\n";
      //   checkingList.forEach(item => {
      //     if (item[0] === undefined || item[0] === false || item[0] === 0) {
      //       bodyMessage = bodyMessage + item[1] + "\n";
      //     }
      //   });
      //   modal.display = true;
      //   (modal.header = "必填欄位缺失"), (modal.body = bodyMessage);

      //   return;
      // }

      api.surveyForm
        .create({
          jwt: store.state.member.jwt,
          type: "產後護理之家",
          data: survey.value
        })
        .then(data => {
          console.log(data);
          Object.assign(modal, {
            type: "success",
            display: true,
            header: "表單填寫成功",
            body: "感謝您的耐心填寫。"
          });
        })
        .catch(error => {
          Object.assign(modal, {
            type: "fail",
            display: true,
            header: "網路連線異常",
            body: error.message
          });
        });
    }

    function backHome() {
      goTo("/FeedBack");
    }

    function closeModal() {
      if (modal.type === "success" && store.state.from === "/FeedBack") {
        goTo("/Feedback");
        return;
      }
      modal.display = false;
    }

    return {
      backHome,
      survey,
      satisfactoinQuestion,
      submitForm,
      satisfactoinTitle,
      modal,
      closeModal
    };
  }
};
</script>
